import { Injectable, inject } from '@angular/core';
import {
  Storage as FirebaseStorage,
  ref,
  uploadString,
  getDownloadURL,
} from '@angular/fire/storage';

@Injectable({ providedIn: 'root' })
export class Storage {
  private firebaseStorage = inject(FirebaseStorage);

  async uploadReceiptPhoto(
    eventId: string,
    dataUrl: string
  ): Promise<{ url: string; path: string }> {
    const uuid = crypto.randomUUID();
    const path = `events/${eventId}/receipts/${uuid}`;
    const storageRef = ref(this.firebaseStorage, path);
    await uploadString(storageRef, dataUrl, 'data_url');
    const url = await getDownloadURL(storageRef);
    return { url, path };
  }

  /**
   * URL de lecture d'un objet Storage, résolue à l'affichage.
   *
   * Les liens de justificatif ne sont plus stockés dans Firestore : le jeton
   * qu'ils portent contourne `storage.rules`, et le document de dépense est
   * lisible par un groupe qui n'a pas le droit de voir les pièces jointes. La
   * résolution ici repasse par les règles, qui exigent `seeExpenseReceipts`.
   *
   * Renvoie `''` si l'accès est refusé ou le fichier absent : l'écran affiche
   * alors son état « non accessible » au lieu d'une image cassée.
   */
  async resolveDownloadUrl(path: string): Promise<string> {
    if (!path) return '';
    try {
      return await getDownloadURL(ref(this.firebaseStorage, path));
    } catch {
      return '';
    }
  }

  async uploadAvatar(userId: string, dataUrl: string): Promise<{ url: string; path: string }> {
    const path = `users/${userId}/avatar/profile`;
    const storageRef = ref(this.firebaseStorage, path);
    await uploadString(storageRef, dataUrl, 'data_url');
    const url = await getDownloadURL(storageRef);
    return { url, path };
  }
}
